module.exports = __webpack_public_path__ + "static/media/notification.8236349.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/notification.mp3
// module id = Xgb6
// module chunks = 1